<div class="fadeinright animation-duration-200">
  <div class="px-5 pt-6">
    <div class="flex justify-content-center">
      <h2>¿Cuanto puedes dar de abono ?</h2>
    </div>
      <div class="flex gap-2 flex-wrap justify-content-center p-3">
        <div class="flex" *ngFor="let value of installment">
          <p-button severity="secondary" [label]="onReturnLabelInstallment(value)" (onClick)="onNavigateSelectedQuotes(value)"></p-button>
        </div>
      </div>
    <div class="flex mt-4">
      <div class="flex w-full justify-content-center p-3">
        <p-button severity="secondary" label="Deseo abonar un monto mayor" icon="pi pi-angle-down" (onClick)="viewPaymentAdd = true" [text]="true"></p-button>
      </div>
    </div>
    <div class="flex gap-2 flex-wrap justify-content-center mt-4 p-3" *ngIf="viewPaymentAdd">
      <div class="flex" *ngFor="let payAdd of installmentBig">
        <p-button severity="secondary" [label]="onReturnLabelInstallment(payAdd)" (onClick)="onNavigateSelectedQuotes(payAdd)"></p-button>
      </div>
    </div>
  </div>
</div>
